module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_roundedHover-4e801b5dc62098192ee3e2fed7937999.jpg";